import { FC, ButtonHTMLAttributes } from 'react';
import { cn } from '../../../utils/helpers';
import { cva } from 'class-variance-authority';
import { TbLoader2 } from 'react-icons/tb';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md';
  isLoading?: boolean;
}

const buttonClasses = cva(
  ['rounded h-fit my-auto', 'px-6', 'text-sm', 'flex items-center gap-2', '!disabled:bg-gray'],
  {
    variants: {
      type: {
        primary: ['bg-blue', 'text-white'],
        secondary: ['border border-[#C3B59B]'],
      },
      size: {
        sm: ['py-2'],
        md: ['py-3'],
      },
    },
    defaultVariants: {
      type: 'primary',
      size: 'md',
    },
  },
);

const Button: FC<Props> = ({ variant = 'primary', size = 'md', className, children, isLoading, ...rest }) => {
  return (
    <button type="button" className={cn(buttonClasses({ type: variant, size }), className)} {...rest}>
      {isLoading ? (
        <>
          <TbLoader2 className="animate-spin" />
          <span>Loading...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
